// Central API client — axios with JWT bearer interceptor.
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('pp_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 401) {
            const path = window.location.pathname;
            if (path !== '/login' && path !== '/') {
                localStorage.removeItem('pp_token');
                localStorage.removeItem('pp_user');
                window.location.href = '/login';
            }
        }
        return Promise.reject(err);
    }
);

export default api;
